/* ==========================================================================
   KASUPP theme scripts — vanilla JS, no dependencies
   ========================================================================== */
(function () {
  'use strict';

  var routes = (window.KASUPP && window.KASUPP.routes) || {};
  var strings = (window.KASUPP && window.KASUPP.strings) || {};

  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
  function on(el, evt, fn) { if (el) el.addEventListener(evt, fn); }

  function formatMoney(cents) {
    var format = (window.KASUPP && window.KASUPP.moneyFormat) || '${{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format.replace(/\{\{\s*amount\s*\}\}/, parts.join('.'));
  }

  /* ---------------------------------------------------------------- Drawers */
  var scrollLocked = false;
  function lockScroll(lock) {
    if (lock === scrollLocked) return;
    scrollLocked = lock;
    document.body.style.overflow = lock ? 'hidden' : '';
  }

  function openDrawer(id) {
    var drawer = document.getElementById(id);
    if (!drawer) return;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    lockScroll(true);
    var focusable = drawer.querySelector('[autofocus], button, a, input');
    if (focusable) setTimeout(function () { focusable.focus(); }, 60);
  }

  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    if (!document.querySelector('.drawer.is-open')) lockScroll(false);
  }

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      e.preventDefault();
      openDrawer(opener.getAttribute('data-drawer-open'));
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var open = document.querySelector('.drawer.is-open');
    if (open) closeDrawer(open);
    var search = document.querySelector('.search-panel.is-open');
    if (search) search.classList.remove('is-open');
  });

  /* ----------------------------------------------------------- Search panel */
  on($('[data-search-toggle]'), 'click', function (e) {
    e.preventDefault();
    var panel = $('.search-panel');
    if (!panel) return;
    var isOpen = panel.classList.toggle('is-open');
    this.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    if (isOpen) {
      var input = panel.querySelector('input[type="search"]');
      if (input) setTimeout(function () { input.focus(); }, 60);
    }
  });

  document.addEventListener('click', function (e) {
    var panel = $('.search-panel.is-open');
    if (!panel) return;
    if (panel.contains(e.target) || e.target.closest('[data-search-toggle]')) return;
    panel.classList.remove('is-open');
  });

  /* --------------------------------------------------------- Sticky header */
  var headerWrap = $('.header-wrap');
  if (headerWrap) {
    var onScrollHeader = function () {
      headerWrap.classList.toggle('is-stuck', window.scrollY > 4);
    };
    window.addEventListener('scroll', onScrollHeader, { passive: true });
    onScrollHeader();
  }

  /* ------------------------------------------------------------- Quantity */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var wrap = btn.closest('.qty');
    var input = wrap && wrap.querySelector('input');
    if (!input) return;
    var step = btn.getAttribute('data-qty') === 'plus' ? 1 : -1;
    var min = parseInt(input.getAttribute('min') || '1', 10);
    var next = (parseInt(input.value, 10) || min) + step;
    input.value = Math.max(min, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ------------------------------------------------------------ Cart logic */
  function getSectionsToRender() {
    return ['cart-drawer', 'cart-icon-bubble'];
  }

  function refreshCartUI() {
    fetch(routes.cart_url + '?section_id=cart-drawer', { headers: { 'Accept': 'text/html' } })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('[data-cart-drawer-content]');
        var target = document.querySelector('[data-cart-drawer-content]');
        if (fresh && target) target.innerHTML = fresh.innerHTML;
        var count = doc.querySelector('[data-cart-count]');
        $$('[data-cart-count]').forEach(function (el) {
          if (!count) return;
          el.textContent = count.textContent;
          el.hidden = count.hidden;
        });
      })
      .catch(function () {});
  }

  function addToCart(form, button) {
    var formData = new FormData(form);
    formData.append('sections', getSectionsToRender().join(','));
    var errorEl = form.querySelector('.product-form__error');
    if (errorEl) { errorEl.classList.remove('is-visible'); errorEl.textContent = ''; }
    if (button) { button.setAttribute('aria-disabled', 'true'); button.classList.add('loading'); }

    return fetch(routes.cart_add_url, {
      method: 'POST',
      headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
      body: formData
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (data.status) {
          if (errorEl) {
            errorEl.textContent = data.description || data.message || strings.cartError || 'Something went wrong.';
            errorEl.classList.add('is-visible');
          }
          return;
        }
        refreshCartUI();
        openDrawer('cart-drawer');
      })
      .catch(function () {
        if (errorEl) {
          errorEl.textContent = strings.cartError || 'Something went wrong. Please try again.';
          errorEl.classList.add('is-visible');
        }
      })
      .finally(function () {
        if (button) { button.removeAttribute('aria-disabled'); button.classList.remove('loading'); }
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-product-form]')) return;
    if (form.querySelector('[data-skip-ajax]')) return;
    e.preventDefault();
    addToCart(form, form.querySelector('[data-add-to-cart]'));
  });

  function changeCartLine(line, quantity) {
    var body = { line: line, quantity: quantity, sections: getSectionsToRender().join(',') };
    document.querySelectorAll('[data-cart-drawer-content], [data-cart-page]').forEach(function (el) {
      el.classList.add('loading');
    });
    return fetch(routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        refreshCartUI();
      })
      .finally(function () {
        document.querySelectorAll('[data-cart-drawer-content], [data-cart-page]').forEach(function (el) {
          el.classList.remove('loading');
        });
      });
  }

  document.addEventListener('click', function (e) {
    var remove = e.target.closest('[data-cart-remove]');
    if (remove) {
      e.preventDefault();
      changeCartLine(remove.getAttribute('data-cart-remove'), 0);
      return;
    }
    var quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      var variantId = quick.getAttribute('data-quick-add');
      var tempForm = document.createElement('form');
      tempForm.innerHTML = '<input type="hidden" name="id" value="' + variantId + '"><input type="hidden" name="quantity" value="1">';
      quick.classList.add('loading');
      addToCart(tempForm, quick).finally(function () { quick.classList.remove('loading'); });
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-cart-qty]');
    if (!input) return;
    changeCartLine(input.getAttribute('data-cart-qty'), parseInt(input.value, 10));
  });

  /* ------------------------------------------------- Shipping protection */
  document.addEventListener('change', function (e) {
    var cb = e.target.closest('[data-protection]');
    if (!cb) return;

    var id = cb.getAttribute('data-variant');
    var row = cb.closest('.cart-protect');
    if (row) row.classList.add('loading');

    var request = cb.checked
      ? fetch(routes.cart_add_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
        })
      : fetch(routes.cart_change_url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: id, quantity: 0 })
        });

    request
      .then(function () {
        if (document.querySelector('[data-cart-page]')) {
          window.location.reload();
          return;
        }
        refreshCartUI();
      })
      .catch(function () {
        cb.checked = !cb.checked;
      })
      .finally(function () {
        if (row) row.classList.remove('loading');
      });
  });

  /* --------------------------------------------------- Product variants */
  function initVariantPickers() {
    $$('[data-variant-picker]').forEach(function (picker) {
      if (picker.dataset.bound === 'true') return;
      picker.dataset.bound = 'true';
      var dataEl = picker.querySelector('[data-variant-json]');
      if (!dataEl) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (err) { return; }
      var section = picker.closest('[data-product-section]') || document;

      picker.addEventListener('change', function () {
        var selected = $$('input:checked', picker).map(function (i) { return i.value; });
        var match = variants.filter(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[i]; });
        })[0];

        var addBtn = section.querySelector('[data-add-to-cart]');
        var idInput = section.querySelector('[data-variant-id]');
        var priceEl = section.querySelector('[data-price-target]');
        var stickyPrice = section.querySelector('[data-sticky-price]');

        if (!match) {
          if (addBtn) {
            addBtn.setAttribute('disabled', 'disabled');
            addBtn.querySelector('span').textContent = strings.unavailable || 'Unavailable';
          }
          return;
        }

        if (idInput) idInput.value = match.id;
        if (addBtn) {
          if (match.available) {
            addBtn.removeAttribute('disabled');
            addBtn.querySelector('span').textContent = strings.addToCart || 'Add to cart';
          } else {
            addBtn.setAttribute('disabled', 'disabled');
            addBtn.querySelector('span').textContent = strings.soldOut || 'Sold out';
          }
        }
        if (priceEl) {
          var html = '<span class="price__current">' + formatMoney(match.price) + '</span>';
          if (match.compare_at_price && match.compare_at_price > match.price) {
            html += '<s class="price__compare">' + formatMoney(match.compare_at_price) + '</s>';
          }
          priceEl.innerHTML = html;
          priceEl.classList.toggle('price--on-sale', !!(match.compare_at_price && match.compare_at_price > match.price));
        }
        if (stickyPrice) stickyPrice.textContent = formatMoney(match.price);

        if (match.featured_media_id) {
          var thumb = section.querySelector('[data-media-id="' + match.featured_media_id + '"]');
          if (thumb) thumb.click();
        }

        if (history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          history.replaceState({}, '', url.toString());
        }
      });
    });
  }

  /* ------------------------------------------------------ Product gallery */
  document.addEventListener('click', function (e) {
    var thumb = e.target.closest('[data-media-id]');
    if (!thumb) return;
    e.preventDefault();
    var gallery = thumb.closest('[data-gallery]');
    if (!gallery) return;
    var main = gallery.querySelector('[data-gallery-main] img');
    var src = thumb.getAttribute('data-media-src');
    if (main && src) {
      main.setAttribute('src', src);
      main.setAttribute('srcset', thumb.getAttribute('data-media-srcset') || '');
      main.setAttribute('alt', thumb.querySelector('img') ? thumb.querySelector('img').alt : '');
    }
    $$('[data-media-id]', gallery).forEach(function (t) { t.classList.remove('is-active'); });
    thumb.classList.add('is-active');
  });

  /* ------------------------------------------- Purchase options (sub/save) */
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-purchase-option]');
    if (!input) return;
    var group = input.closest('.purchase-options');
    if (!group) return;
    $$('.purchase-option', group).forEach(function (opt) {
      var radio = opt.querySelector('input[type="radio"]');
      opt.classList.toggle('is-selected', !!(radio && radio.checked));
      var plans = opt.querySelector('.purchase-option__selling-plans');
      if (plans) plans.hidden = !(radio && radio.checked);
    });
    var form = input.closest('form');
    var planSelect = form && form.querySelector('[data-selling-plan]');
    if (planSelect) planSelect.disabled = input.value === 'onetime';
  });

  /* ------------------------------------------------------ Sticky add to cart */
  var stickyBar = $('[data-sticky-atc]');
  if (stickyBar) {
    var anchor = $('[data-atc-anchor]');
    if (anchor && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
        });
      }, { threshold: 0 }).observe(anchor);
    }
  }

  /* ----------------------------------------------- Collection sort + facets */
  on($('[data-sort-by]'), 'change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });

  $$('[data-facet-form]').forEach(function (form) {
    form.addEventListener('change', function (e) {
      if (e.target.matches('input[type="number"]')) return;
      form.submit();
    });
  });

  /* --------------------------------------------------------- Announcement */
  var announcement = $('[data-announcement]');
  if (announcement) {
    var slides = $$('.announcement__slide', announcement);
    if (slides.length > 1) {
      var idx = 0;
      setInterval(function () {
        slides[idx].classList.remove('is-active');
        idx = (idx + 1) % slides.length;
        slides[idx].classList.add('is-active');
      }, 5000);
    }
  }

  /* -------------------------------------------------------- Reveal on scroll */
  if ('IntersectionObserver' in window) {
    var revealObserver = new IntersectionObserver(function (entries, obs) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        obs.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    $$('.reveal').forEach(function (el) { revealObserver.observe(el); });
  } else {
    $$('.reveal').forEach(function (el) { el.classList.add('is-visible'); });
  }

  /* --------------------------------------------------- Product recommendations */
  function initRecommendations() {
    $$('[data-recommendations]').forEach(function (el) {
      if (el.dataset.loaded === 'true') return;
      el.dataset.loaded = 'true';
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var section = doc.querySelector('.shopify-section');
          if (section && section.innerHTML.trim()) el.outerHTML = section.innerHTML;
        })
        .catch(function () {});
    });
  }

  /* -------------------------------------------------------- Init + Shopify */
  function init() {
    initVariantPickers();
    initRecommendations();
  }
  init();

  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:select', function (e) {
    var drawerId = e.target.querySelector('.drawer') && e.target.querySelector('.drawer').id;
    if (drawerId) openDrawer(drawerId);
  });
})();
